module.exports = __webpack_public_path__ + "img/ar.4ba4f5ad.png";